//
//
//
//
//
//

import Vue from "vue"
export default {
    name: 'app',
    data () {
        return {
            customerInfo: {},
            imei: ""
        }
    },
    methods: {
        // async apiReady () {
        //     let access_token = this.cookieHelper.get('access_token');
        //     let signParams = {
        //         "nonce": this.getRandomString(12),
        //         "timestamp": new Date().getTime()
        //     };
        //     if (access_token) {
        //         let tempData = await this.getLoginCustomerImei().catch(() =>{});
        //         if (tempData && tempData.data && tempData.data.imei) {
        //             this.imei = tempData.data.imei;
        //         }
        //         signParams.web_token = localStorage.username;
        //     } else {
        //         signParams.web_token = `WEB_${this.getuDeskSessionKey()}`;
        //     }
        //     let tempData2 = await this.getuDeskSignature(signParams).catch(() => {});
        //     if (tempData2 && tempData2.data) {
        //         signParams.signature = tempData2.data;
        //     }
        //     this.customerInfo = this.getuDeskCustomerInfo(signParams);

        //     // <!-- uDesk客服接入 -->
        //     (function(a,h,c,b,f,g) {
        //         a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};
        //         g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)
        //     })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");

        //     // 初始化uDesk
        //     this.inituDesk();
        // },
        inituDesk () {               // uDesk客服接入init
            let code = "2k468g44",
                link = this.getuDeskLink(),
                session_key = this.getuDeskSessionKey(),
                language = this.getuDeskLanguage();

            let config = {
                "code": code,
                "link": link,
                "language": language,
                "session_key": session_key,
                "mobile": {
                    "mode": "blank", // 独立窗口模式
                    "selector": ".btn_uDesk"
                }
            };
            config.manualInit = deviceWidth > 768;
            config.customer = this.customerInfo;
            ud(config);
        },
        getuDeskCustomerInfo (obj) {        // uDesk客服发送客户信息
            let tempUserInfo = localStorage.userInfo,
                userInfo = {};
            if (tempUserInfo) {
                userInfo = JSON.parse(tempUserInfo);
            }
            let customer = {
                "c_name": `WEB_${this.getuDeskSessionKey()}`
            };
            if (userInfo && userInfo.registerType === "PHONE") {

                // "账户"、"IMEI1"为客服自定义字段
                customer.c_cf_账户 = userInfo.phone;
                if (this.imei) {
                    customer.c_cf_IMEI1 = this.imei;
                }
            }
            if (userInfo && userInfo.registerType === "EMAIL") {

                // "账户"、"IMEI1"为客服自定义字段
                customer.c_cf_账户 = userInfo.email;
                if (this.imei) {
                    customer.c_cf_IMEI1 = this.imei;
                }
            }

            customer = {...customer, ...obj};
            return customer;
        },
        getuDeskLink () {                // uDesk客服接入link
            let commonLink = "//ucloudlink.udesk.cn/im_client/",
                normal_id = "58735",                            // 通用客服ID
                us_id = "58737",                                // 美国站点专用客服ID
                ca_id = "129711",                               // 加拿大站专用客服ID
                g_iso = this.cookieHelper.get("g_iso") || "CN";
            let normalLink = commonLink + "?web_plugin_id=" + normal_id,
                usLink = commonLink + "?web_plugin_id=" + us_id,
                caLink = commonLink + "?web_plugin_id=" + ca_id,
                link = "";

            if (g_iso.toUpperCase() === 'US') {
                link = usLink;
            } else if (g_iso.toUpperCase() === 'CA') {
                link = caLink;
            } else {
                link = normalLink;
            }

            return link;
        },
        getuDeskLanguage () {                // uDesk客服接入language
            let languageArray = ["zh-cn", "zh-TW", "en-us"], // 简体中文、繁体中文、英文
                language = this.cookieHelper.get("language") || "zh-CN",
                uDeskLanguage = "";

            if (language === "zh-HK" || language === "zh-TW") {
                uDeskLanguage = languageArray[1];
            } else if (language === "en-US") {
                uDeskLanguage = languageArray[2];
            } else {
                uDeskLanguage = languageArray[0];
            }
            return uDeskLanguage;
        },
        getuDeskSessionKey () {              // uDesk客服接入session_key
            let sessionKey = localStorage.sessionKey;
            if (sessionKey) {
                return sessionKey;
            } else {
                let tempKey = this.getRandomString(6);
                localStorage.setItem("sessionKey", tempKey);
                return tempKey;
            }
        },
        getRandomString (n) {
            // 生成n位字符串
            // randomArray 生成随机字母，数字的数组容器[A-Za-z0-9]
            let randomArray = [],
                randomString = "",
                len;

            for (let i = 0; i < 26; i++) {
                randomArray.push(String.fromCharCode(i + 65));
                randomArray.push(String.fromCharCode(i + 97));
            }
            for (let j = 0; j <= 9; j++) {
                randomArray.push(j);
            }
            len = randomArray.length;

            do {
                randomString += randomArray[Math.floor(Math.random() * len)];
                n--;
            } while (n > 0);

            return randomString;
        },
        checkGiso () {
            let that = this;
            let access_token = this.cookieHelper.get('access_token');
            let SL_COUNTRY = this.cookieHelper.get('SL_COUNTRY') || 'US'; // 临时
            let GM_COUNTRY = this.cookieHelper.get('GM_COUNTRY');

            // 如果登陆，并且选择地区与账号地区不同
            if(access_token && access_token.length > 0 && GM_COUNTRY !== SL_COUNTRY){
                this.$http.post(this.$api.interfaces.getCountryInfo + "?giso=" + SL_COUNTRY, {
                    keyword: "",
                    search: 1
                }).then(d => {
                    let country_name = '';
                    d = d.data;
                    for(let key in d){
                        if(d.hasOwnProperty(key) && d[key].iso2 === GM_COUNTRY){
                            country_name = d[key].countryName;
                            break;
                        }
                    }

                    if(country_name){
                        let title, content;
                        title = that.$t('footer.belongs') + country_name + that.$t('footer.site');
                        content = that.$t('footer.switchWebsite');
                        that.$vux.confirm.show({
                            title: title,
                            content: content,
                            confirmText: that.$t('common.confirm'),
                            cancelText: that.$t('common.cancel'),
                            onCancel () {
                                let uri = location.pathname.replace(/\/[A-Z]{2}/, function(a){
                                    return '/' + GM_COUNTRY;
                                });
                                location.replace(uri);
                            },
                            onConfirm () {
                                that.cookieHelper.remove("access_token",{domain: "." + location.hostname});
                                that.cookieHelper.remove("GM_COUNTRY",{domain: "." + location.hostname});
                                that.cookieHelper.remove("SL_COUNTRY",{domain: "." + location.hostname});
                                that.cookieHelper.remove("g_iso",{domain: "." + location.hostname});
                                localStorage.clear();
                                sessionStorage.clear();
                                location.reload();
                            }
                        })
                    }
                });
            }
        },
        getLoginCustomerImei() {
            // 获取登录账户的绑定IMEI
            Vue.prototype.NotInterceptors = true;
            return this.$http.post(this.$api.equipmentManagement.queryDeviceBindingInfo , {
                loginCustomerId: localStorage.getItem('loginCustomerId'),
                customerName: localStorage.getItem('username')
            });
        },
        getuDeskSignature(obj) {
            // 获取生成的uDesk鉴权字符串
            return this.$http.post(this.$api.interfaces.getuDeskSign, obj);
        },
        // 获取或保存用户协议和隐私政策的版本号
        pushInformationVersion(obj) {
            return this.$http.post(this.$api.interfaces.pushInformation, obj);
        },
        // 检测登录账号是否需要提示用户协议和隐私政策变更
        checkPolicyVersion() {
            if (this.cookieHelper.get("access_token")) {
                let param = {
                    userCode: localStorage.username,
                    langType: this.commonHelper.getLanguage(this.cookieHelper.get("language")),
                    iso: this.cookieHelper.get("g_iso")
                };
                this.pushInformationVersion(param).then(response => {
                    // 返回结果 push为true 提示用户政策变更
                    if (response.data && response.data.push === true) {
                        this.$vux.confirm.show({
                            title: this.$t('privacyPolicy.changeDate'),
                            content: this.$t('privacyPolicy.changeContain') + '<div style="padding: 0.1rem 0">' + this.$t('privacyPolicy.changeContain2') + '</div>' + this.$t('privacyPolicy.changeContain3'),
                            confirmText: this.$t('privacyPolicy.agree'),
                            cancelText: this.$t('privacyPolicy.noagree'),
                            onCancel: () => {
                                this.cookieHelper.remove("access_token",{domain: "." + location.hostname});
                                localStorage.clear();
                                sessionStorage.clear();
                                location.reload();
                            },
                            onConfirm: () => {
                                // 选择同意，提交变更版本信息
                                param.registrationAgreement = response.data.registrationAgreement;
                                param.privacyPolicy = response.data.privacyPolicy;
                                this.pushInformationVersion(param);
                            }
                        })
                    }
                })
            }
        }
    },
    mounted (){
        // this.checkGiso();
        this.checkPolicyVersion();
    }
}



// WEBPACK FOOTER //
// ./src/App.vue